import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const DialogCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1.5),
  right: theme.spacing(1.5),
  zIndex: 1,
}));

export default DialogCloseButton;
